module.exports = __webpack_public_path__ + "img/rmcs_3.652399e5.jpg";